import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * DripNeedle · extras del carrito.
 * Añade un accesorio con un clic y deja que Horizon refresque el drawer
 * (mismo mecanismo que usa el propio tema: CartLinesUpdateEvent + sections).
 */

const SECTION_ID = 'cart-drawer-section';

/** @param {HTMLButtonElement} button */
async function addToCart(button) {
  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Añadiendo…';

  const routes = window.Theme?.routes ?? {};
  const deferred = CartLinesUpdateEvent.createPromise();

  // Avisa al tema (icono del carrito, drawer...) de que se está añadiendo una línea.
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const addResponse = await fetch(routes.cart_add_url ?? '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: SECTION_ID,
      }),
    });

    const addData = await addResponse.json();
    if (!addResponse.ok || addData.status) {
      throw new Error(addData.description || addData.message || 'No se pudo añadir al carrito');
    }

    const cartResponse = await fetch(`${routes.cart_url ?? '/cart'}.json`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    const cart = await cartResponse.json();

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'cart-extras',
        sourceId: 'cart-extras-upsell',
        itemCount: 1,
        productId: button.dataset.productId,
        sections: addData.sections,
        didError: false,
      },
    });
  } catch (error) {
    console.error('[cart-extras]', error);
    deferred.reject(error);
    button.disabled = false;
    button.textContent = originalLabel;
  }
}

if (!window.__cartExtrasBound) {
  window.__cartExtrasBound = true;

  // Delegación en document: sobrevive a los re-renders (morph) del drawer.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = /** @type {HTMLButtonElement | null} */ (target?.closest('[data-cart-extras-add]'));
    if (!button || button.disabled) return;

    event.preventDefault();
    addToCart(button);
  });
}